import { Progress, Typography, Modal } from 'antd';
import { useContext, useEffect, useState } from 'react';
import LoaderIcon from '../../../../../Assets/Mahindra/circular-determinate.svg';
import styles from './index.module.css';
import { AppContext } from '../../../../../App';
import { LOADERTYPE } from '../../../../../Utils/types';

const MahindraLoader: React.FC = () => {
  const { loaderType, isLoading }: any = useContext(AppContext);

  return (
    <Modal open={isLoading} footer={null} closable={false} centered width={300}>
      <div className={styles.container} style={{ textAlign: 'center' }}>
        <img src={LoaderIcon} alt='Loader' className={styles.loaderIcon} />
        <Typography.Text className={styles.loaderText}>
          {loaderType === LOADERTYPE.GENERIC
            ? 'Fetching your financial data securely!'
            : 'Please wait while we analyse your spends '}
        </Typography.Text>
      </div>
      <div className={styles.separator}></div>
      <p className={styles.loader_bottom_text}>Please do not close the app.</p>
    </Modal>
  );
};

export default MahindraLoader;
